import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationType } from '@app/shared/interfaces';
import { InboxAISettingsGroup, SettingsService } from '@app/shared/services/settings/settings.service';
import { TitleService } from '@app/shared/services/title/title.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sbnb-gx-inbox-ai-overview',
  templateUrl: './inbox-ai-overview.component.html',
  styleUrls: ['./inbox-ai-overview.component.scss'],
})
export class InboxAiOverviewComponent implements OnInit {
  isLoading = true;
  public settingsGroups$: Observable<InboxAISettingsGroup[]>;
  public displayedColumns: string[] = ['status', 'name', 'hosts', 'properties', 'platforms'];

  constructor(
    private titleService: TitleService,
    private settingsService: SettingsService,
    private router: Router,
    private toast: ToastNotificationsService
  ) {}

  ngOnInit() {
    this.titleService.manuallySet('Inbox AI Settings');
    this.loadSettingsGroups();
  }

  loadSettingsGroups() {
    this.isLoading = true;
    this.settingsGroups$ = this.settingsService.getInboxAISettingsGroups().pipe(
      map(groups => {
        this.isLoading = false;
        return groups;
      })
    );
  }

  onRowClick(group: InboxAISettingsGroup) {
    this.router.navigate(['/gx/inbox-ai/settings', group.id]);
  }

  createNewGroup() {
    this.settingsService.createSettingsGroup().subscribe({
      next: (group) => {
        this.settingsGroups$ = this.settingsService.getInboxAISettingsGroups().pipe(
          map(groups => {
            this.isLoading = false;
            return groups;
          })
        );

        this.router.navigate(['/gx/inbox-ai/settings', group.id]);
      },
      error: () => {
        this.toast.open('Failed to create new group', 'Dismiss', NotificationType.Error);
      }
    });
  }
}
